import fetchYearOverviewReport from '../Services/fetchYearOverviewReport';
import fetchEstimatesByClientReport from '../Services/fetchEstimatesByClientReport';
import fetchLastThreeMonthsReport from '../Services/fetchLastThreeMonthsReport';
import fetchTopClientsReport from '../Services/fetchTopClientsReport';
import fetchServicesBreakdownReport from '../Services/fetchServicesBreakdownReport';
import fetchNewProjectsWithOrderReport from '../Services/fetchNewProjectsWithOrderReport';
import fetchBasicDashboardData from '../Services/fetchBasicDashboardData';
import fetchClients from '../../../Core/Services/fetchClients';
import { isAdvanced, isPremium } from '../../../Common';

export default () => async (dispatch) => {

  const showAdvancedFeatures = isAdvanced() || isPremium();

  if (showAdvancedFeatures) {
    // Fetch advanced reports for Advanced/Premium users
    dispatch(fetchYearOverviewReport());
    dispatch(fetchEstimatesByClientReport());
    dispatch(fetchLastThreeMonthsReport());
    dispatch(fetchTopClientsReport());
    dispatch(fetchServicesBreakdownReport());
    dispatch(fetchNewProjectsWithOrderReport());
    dispatch(fetchClients());
  } else {
    // Fetch basic dashboard data for Basic users
    dispatch(fetchBasicDashboardData());
  }

}